// ============================================================================
// TIME ENTRY TEMPLATE HOOKS — placeholders for future implementation
// ============================================================================

import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { GetTicketsDocument, Time_Entries } from "@/src/gql/graphql";

const NOT_IMPLEMENTED = "Time entry templates not implemented yet";

const STUB_QUERY_STATE = {
  isLoading: false as const,
  error: null,
  isError: false as const,
  isSuccess: true as const,
};

function notImplementedMutation<TArg>() {
  return {
    mutate: async (_arg: TArg): Promise<never> => {
      throw new Error(NOT_IMPLEMENTED);
    },
    ...STUB_QUERY_STATE,
  };
}

// Module scope: one result object so `data` keeps one identity across renders.
const NO_TIME_ENTRY_TEMPLATES: { data: Time_Entries[] } & typeof STUB_QUERY_STATE = {
  data: [],
  ...STUB_QUERY_STATE,
};

export function useTimeEntryTemplates(_params?: { includeInactive?: boolean }) {
  return NO_TIME_ENTRY_TEMPLATES;
}

export function useCreateTimeEntryTemplate() {
  return notImplementedMutation<Partial<Time_Entries>>();
}

export function useUpdateTimeEntryTemplate() {
  return notImplementedMutation<Partial<Time_Entries>>();
}

export function useDeleteTimeEntryTemplate() {
  return notImplementedMutation<string>();
}

export function useToggleTimeEntryTemplateActive() {
  return notImplementedMutation<{ id: string; is_active: boolean }>();
}

export function useAutoGenerateTicketId() {
  // Query intentionally skipped — logic not implemented yet
  const { data: _ticketsData } = useQuery(GetTicketsDocument, {
    variables: { id: "" },
    errorPolicy: "all",
    skip: true,
  });

  const autoGenerateTicketId = useMemo(() => {
    return (_description: string): string => {
      return crypto.randomUUID();
    };
  }, []);

  return {
    autoGenerateTicketId,
    ...STUB_QUERY_STATE,
  };
}
